import type { RouteRecordRaw } from 'vue-router'

export const adminBooksRoutes: RouteRecordRaw[] = [
  {
    path: '/admin/books',
    name: 'admin-books',
    component: () => import('./pages/AdminBooksPage.vue'),
    meta: { requiresAuth: true, requiresAdmin: true },
  },
  {
    path: '/admin/books/:id',
    name: 'admin-book-detail',
    component: () => import('./pages/AdminBookDetailsPage.vue'),
    meta: { requiresAuth: true, requiresAdmin: true },
  },
]
